import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

export type SectionContentProps = ComponentProps<'div'>;

export function SectionContent({ className, ...props }: SectionContentProps) {
  return (
    <div
      className={twMerge(
        'lg:max-w-content-w flex size-full max-w-11/12 flex-1 flex-col py-24 lg:px-10',
        className,
      )}
      {...props}
    />
  );
}
